import { z } from 'zod'

const EducationHistorySchema = z.object({
  id: z.string().nullable().optional(),
  degree: z.string().nullable().optional(),
  fieldOfStudy: z.string().nullable().optional(),
  organisationName: z.string(),
  startDate: z.string(),
  endDate: z.string().nullable(),
  // fields id
  degreeId: z.string().uuid(),
  fieldOfStudyId: z.string().uuid(),
  organisationNameId: z.string().uuid().optional().nullable().optional()
})

export const EducationHistoryOptionalSchema = EducationHistorySchema.extend({
  id: z.string().nullable().optional(),
  organisationName: z.string().nullable().optional(),
  startDate: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  degreeId: z.string().uuid().nullable().optional(),
  fieldOfStudyId: z.string().uuid().nullable().optional()
})

export default EducationHistorySchema
